<template>
  <nav
    v-if="currentPage >= 1 && lastPage > 1"
    class="pagination flex items-center gap-x-[17px] text-[14px] leading-[16px] [&>a]:cursor-pointer [&>a]:text-blue"
  >
    <a
      key="previous"
      :class="{
        'pointer-events-none !text-gray-300': !(
          pages.length > 1 && currentPage != 1
        ),
      }"
      href="javascript:;"
      @click="paginate(1)"
    >
      {{ '<<' }}
    </a>

    <a
      v-if="pages.length > 3"
      key="pre_previous"
      :class="{
        'pointer-events-none !text-gray-300': !(
          pages.length > 1 && currentPage != 1
        ),
      }"
      href="javascript:;"
      @click="paginate(currentPage - 1)"
    >
      {{ '<' }}
    </a>

    <template v-for="(page, i) in pages" :key="i">
      <a
        href="javascript:;"
        class="hidden sm:block"
        :class="{
          '!text-grey-mid !pointer-events-none !block': page == currentPage,
          'pointer-events-none': page == '...',
        }"
        @click="paginate(page)"
      >
        {{ page }}
      </a>
    </template>

    <a
      v-if="pages.length > 3"
      key="pre_next"
      :class="{
        'pointer-events-none !text-gray-300': !(
          pages.length > 1 && currentPage != lastPage
        ),
      }"
      href="javascript:;"
      @click="paginate(currentPage + 1)"
    >
      {{ '>' }}
    </a>

    <a
      key="next"
      :class="{
        'pointer-events-none !text-gray-300': !(
          pages.length > 1 && currentPage != lastPage
        ),
      }"
      href="javascript:;"
      @click="paginate(pages.at(-1))"
    >
      {{ '>>' }}
    </a>
  </nav>
</template>

<script setup>
import _ from 'lodash';
import { computed } from 'vue';
const emit = defineEmits(['update:currentPage', 'change']);
const props = defineProps({
  currentPage: {
    type: Number,
    default: 0,
  },
  lastPage: {
    type: Number,
    default: 0,
  },
  light: {
    type: Boolean,
    default: false,
  },
});

const generatePages = (c, m) => {
  let current = c,
    last = m,
    delta = 2,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithDots = [],
    l;

  for (let i = 1; i <= last; i++) {
    if (i == 1 || i == last || (i >= left && i < right)) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
};
const pages = computed(() => {
  return generatePages(props.currentPage, props.lastPage);
});
const paginate = _.debounce((p) => {
  if (p == props.currentPage) return;
  emit('update:currentPage', p);
  emit('change', p);
}, 300);
</script>

<style scoped></style>
